"use client";

import { useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Menu, X } from "lucide-react";
import { NAV, SITE } from "@/lib/site";
import Wordmark from "@/components/Wordmark";

function isActive(pathname: string, href: string): boolean {
  if (href === "/") return pathname === "/";
  return pathname.startsWith(href);
}

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const pathname = usePathname() || "/";

  return (
    <header className="navbar-solid sticky top-0 z-50">
      <nav className="container-xl flex items-center justify-between py-[18px]">
        <Link href="/" aria-label={SITE.name}>
          <Wordmark variant="nav" />
        </Link>

        {/* Desktop nav */}
        <div className="hidden items-center gap-8 lg:flex">
          {NAV.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              data-active={isActive(pathname, item.href)}
              className="nav-link-underline text-[12.5px] uppercase tracking-[0.14em] text-[#D8CBB4] transition-colors hover:text-cream"
            >
              {item.label}
            </Link>
          ))}
          <Link
            href="/contact/"
            className="btn-primary text-xs uppercase tracking-wide"
          >
            Free Estimate
          </Link>
        </div>

        {/* Mobile toggle */}
        <button
          type="button"
          aria-label={mobileOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen((v) => !v)}
          className="text-cream lg:hidden"
        >
          {mobileOpen ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </nav>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="border-t border-[rgba(203,168,107,0.22)] bg-navy lg:hidden">
          <div className="container-xl flex flex-col py-3">
            {NAV.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="border-b border-[rgba(203,168,107,0.15)] py-3 text-[13px] uppercase tracking-[0.14em] text-[#D8CBB4]"
              >
                {item.label}
              </Link>
            ))}
            <Link
              href="/contact/"
              onClick={() => setMobileOpen(false)}
              className="btn-primary mt-4 text-xs uppercase"
            >
              Free Estimate
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
